import parse from "html-react-parser";
import "./accordion.css";
import { useState } from "react";

const DropDownPlus = ({ data }) => {
  const [isOpen, setIsOpen] = useState([false, false, false, false]);

  const handleOpenAnswer = (index) => {
    setIsOpen((prevOpen) =>
      prevOpen.map((item, i) => (i === index ? !item : item))
    );
  };

  return (
    <div className="sub-card-container">
      {data.map((item, i) => (
        <div key={i} className="sub-card-box">
          <div className="card-question" onClick={() => handleOpenAnswer(i)}>
            <h5>{parse(item.question)}</h5>
          </div>
          <div
            className="sub-card-text"
            style={{ display: isOpen[i] ? "block" : "none" }}
          >
            {parse(item.answer)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DropDownPlus;

{
  /*
  
  The "data" passed as a prop must include "question" and "answer" keys:

  const data = [
    {question: "Question A",
    asnwer: "Answer A"}, etc.
  ]

  */
}
